import './box.css'
import React from 'react'

function Box() {
  return (
    <div className='box'>
        <div className="container">
            <h2>🚗 مرحباً بك في مركز دكتور كار لصيانة السيارات، حيث الجودة والضمان هما شعارنا! 🚗</h2>
        </div>
    </div>
  )
}

export default Box